module.exports = __webpack_public_path__ + "img/websites.9cd78772.svg";